import { v4 as uuidv4 } from 'uuid';

import { Menu } from '../../../../vtex-apps/menu/Menu/default';
import { MenuItem } from '../../../../vtex-apps/menu/MenuItem/default';
import { SubmenuAccordion } from '../../../../vtex-apps/menu/SubmenuAccordion/default';

const StoreMenuMobile = () => {
	return {
		componentName: 'Menu',
		componentGroup: 'StoreMenuMobile',
		componentId: uuidv4(),
		variables,
		props: Menu({ blockClass: 'menu-mob-1__menu' }).props,
		childrenComponents: [
			MenuItem(
				{ blockClass: 'todas-as-categorias-mob', itemProps: { text: 'Todas as Categorias' } },
				[],
				[
					SubmenuAccordion({ blockClass: 'menu-mob-1__submenu' }, [
						Menu({
							blockClass: 'menu-mob-1__submenu',
							items: [
								MenuItem({
									blockClass: 'menu-mob-1__submenu-item',
									id: 'menu-item-category-mobile-2',
									type: 'custom',
									itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
								}),
								MenuItem({
									blockClass: 'menu-mob-1__submenu-item',
									id: 'menu-item-category-mobile-2',
									type: 'custom',
									itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
								}),
								MenuItem({
									blockClass: 'menu-mob-1__submenu-item',
									id: 'menu-item-category-mobile-2',
									type: 'custom',
									itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
								}),
							],
						}),
					]),
				],
			),
			MenuItem(
				{
					blockClass: 'menu-mob-1__menu-item',
					id: 'menu-item-category-mobile-2',
					type: 'custom',
					itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
				},
				[],
				[
					SubmenuAccordion({ blockClass: 'menu-mob-1__submenu' }, [
						Menu({
							blockClass: 'menu-mob-1__submenu',
							items: [
								MenuItem({
									blockClass: 'menu-mob-1__submenu-item',
									id: 'menu-item-category-mobile-2',
									type: 'custom',
									itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
								}),
								MenuItem({
									blockClass: 'menu-mob-1__submenu-item',
									id: 'menu-item-category-mobile-2',
									type: 'custom',
									itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
								}),
								MenuItem({
									blockClass: 'menu-mob-1__submenu-item',
									id: 'menu-item-category-mobile-2',
									type: 'custom',
									itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
								}),
							],
						}),
					]),
				],
			),
			MenuItem(
				{
					blockClass: 'menu-mob-1__menu-item',
					id: 'menu-item-category-mobile-2',
					type: 'custom',
					itemProps: { categoryId: 10, text: 'Category 18', itemType: 'category' },
				},
				[],
				[
					SubmenuAccordion({ blockClass: 'menu-mob-1__submenu' }, [
						Menu({
							blockClass: 'menu-mob-1__submenu',
							items: [
								MenuItem({
									blockClass: 'menu-mob-1__submenu-item',
									id: 'menu-item-category-mobile-2',
									type: 'custom',
									itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
								}),
								MenuItem({
									blockClass: 'menu-mob-1__submenu-item',
									id: 'menu-item-category-mobile-2',
									type: 'custom',
									itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
								}),
								MenuItem({
									blockClass: 'menu-mob-1__submenu-item',
									id: 'menu-item-category-mobile-2',
									type: 'custom',
									itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
								}),
							],
						}),
					]),
				],
			),
			MenuItem(
				{
					blockClass: 'menu-mob-1__menu-item',
					id: 'menu-item-category-mobile-2',
					type: 'custom',
					itemProps: { categoryId: 10, text: 'Category 19', itemType: 'category' },
				},
				[],
				[
					SubmenuAccordion({ blockClass: 'menu-mob-1__submenu' }, [
						Menu({
							blockClass: 'menu-mob-1__submenu',
							items: [
								MenuItem({
									blockClass: 'menu-mob-1__submenu-item',
									id: 'menu-item-category-mobile-2',
									type: 'custom',
									itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
								}),
								MenuItem({
									blockClass: 'menu-mob-1__submenu-item',
									id: 'menu-item-category-mobile-2',
									type: 'custom',
									itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
								}),
								MenuItem({
									blockClass: 'menu-mob-1__submenu-item',
									id: 'menu-item-category-mobile-2',
									type: 'custom',
									itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
								}),
							],
						}),
					]),
				],
			),
			MenuItem(
				{
					blockClass: 'menu-mob-1__menu-item',
					id: 'menu-item-category-mobile-2',
					type: 'custom',
					itemProps: { categoryId: 10, text: 'Category 20', itemType: 'category' },
				},
				[],
				[
					SubmenuAccordion({ blockClass: 'menu-mob-1__submenu' }, [
						Menu({
							blockClass: 'menu-mob-1__submenu',
							items: [
								MenuItem({
									blockClass: 'menu-mob-1__submenu-item',
									id: 'menu-item-category-mobile-2',
									type: 'custom',
									itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
								}),
								MenuItem({
									blockClass: 'menu-mob-1__submenu-item',
									id: 'menu-item-category-mobile-2',
									type: 'custom',
									itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
								}),
								MenuItem({
									blockClass: 'menu-mob-1__submenu-item',
									id: 'menu-item-category-mobile-2',
									type: 'custom',
									itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
								}),
							],
						}),
					]),
				],
			),
			MenuItem(
				{
					blockClass: 'menu-mob-1__menu-item',
					id: 'menu-item-category-mobile-2',
					type: 'custom',
					itemProps: { categoryId: 10, text: 'Category 21', itemType: 'category' },
				},
				[],
				[
					SubmenuAccordion({ blockClass: 'menu-mob-1__submenu' }, [
						Menu({
							blockClass: 'menu-mob-1__submenu',
							items: [
								MenuItem({
									blockClass: 'menu-mob-1__submenu-item',
									id: 'menu-item-category-mobile-2',
									type: 'custom',
									itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
								}),
								MenuItem({
									blockClass: 'menu-mob-1__submenu-item',
									id: 'menu-item-category-mobile-2',
									type: 'custom',
									itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
								}),
								MenuItem({
									blockClass: 'menu-mob-1__submenu-item',
									id: 'menu-item-category-mobile-2',
									type: 'custom',
									itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
								}),
							],
						}),
					]),
				],
			),
			MenuItem(
				{
					blockClass: 'menu-mob-1__menu-item',
					id: 'menu-item-category-apparel',
					type: 'custom',
					itemProps: { text: 'Apparel & Accessories' },
				},
				[],
				[
					SubmenuAccordion({ blockClass: 'menu-mob-1__submenu' }, [
						Menu({
							blockClass: 'menu-mob-1__submenu',
							items: [
								MenuItem({
									blockClass: 'menu-mob-1__submenu-item',
									id: 'menu-item-category-mobile-2',
									type: 'custom',
									itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
								}),
								MenuItem({
									blockClass: 'menu-mob-1__submenu-item',
									id: 'menu-item-category-mobile-2',
									type: 'custom',
									itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
								}),
								MenuItem({
									blockClass: 'menu-mob-1__submenu-item',
									id: 'menu-item-category-mobile-2',
									type: 'custom',
									itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
								}),
							],
						}),
					]),
				],
			),
		],
	};
};

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--header-mob-1-menu-bg-color', name: 'Menu Background' },
			{ from: '--white', to: '--header-mob-1-submenu-bg-color', name: 'Submenu Background' },
			{ from: '--text-color-1-dark', to: '--header-mob-1-menu-text-color', name: 'Menu Text' },
			{ from: '--text-color-1-dark', to: '--header-mob-1-submenu-text-color', name: 'Submenu Text' },
			{ from: '--text-color-1-dark', to: '--header-mob-1-allcat-color', name: 'All Categories Text' },
			//submenu item hover
			{ from: '--neutral-color-high-medium', to: '--header-mob-1-menuitem-bc', name: 'MenuItem Border' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xs', to: '--header-mob-1-menu-fs', name: 'Menu' },
			//submenu text size
			{ from: '--font-size-xs', to: '--header-mob-1-submenu-fs', name: 'Submenu' },
		],
	},
	//menuitem borderWidth
	{
		type: 'borderWidth',
		list: [{ from: '--border-width-hairline', to: '--header-mob-1-menuitem-bw', name: 'MenuItem Border' }],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-400', to: '--header-mob-1-menu-fw', name: 'Menu' },
			{ from: '--font-weight-400', to: '--header-mob-1-allcat-fw', name: 'All Categories' },
			//submenu
			{ from: '--font-weight-400', to: '--header-mob-1-submenu-fw', name: 'Submenu' },
		],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-xxxs', to: '--header-mob-1-menuitem-lateral-padding', name: 'Menuitem Lateral Padding' },
			{ from: '--spacing-xxs', to: '--header-mob-1-submenu-lateral-padding', name: 'Submenu Lateral Padding' },
			{ from: '--spacing-nano', to: '--header-mob-1-menu-gap', name: 'Menu Items Gap' },
			{ from: '--spacing-nano', to: '--header-mob-1-submenu-gap', name: 'Submenu Items Gap' },
			//submenu lateral padding
		],
	},
	//typography for menu and submenu
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--header-mob-1-menu-typography', name: 'Menu' },
			{ from: '--main-font', to: '--header-mob-1-submenu-typography', name: 'Submenu' },
		],
	},
];

export default StoreMenuMobile;
